import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function Register() {
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await register(form.email, form.password, form.name);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#f5f4f0',fontFamily:'sans-serif'}}>
      <div style={{background:'#fff',border:'0.5px solid rgba(0,0,0,0.1)',borderRadius:'16px',padding:'2.5rem',width:'100%',maxWidth:'400px'}}>
        <div style={{fontSize:'18px',fontWeight:'600',marginBottom:'1.5rem'}}>SellerDash</div>
        <h1 style={{fontSize:'22px',fontWeight:'500',margin:'0 0 4px'}}>Start your free trial</h1>
        <p style={{fontSize:'13px',color:'#777',margin:'0 0 1.5rem'}}>14 days free, no credit card required</p>
        {error && <div style={{background:'#fef2f2',color:'#991b1b',borderRadius:'8px',padding:'10px 12px',fontSize:'13px',marginBottom:'1rem'}}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <label style={{display:'block',fontSize:'12px',fontWeight:'500',color:'#555',marginBottom:'4px'}}>Your name</label>
          <input type="text" value={form.name} onChange={set('name')} placeholder="Jane Smith"
            style={{width:'100%',padding:'9px 12px',border:'0.5px solid #ddd',borderRadius:'8px',fontSize:'14px',marginBottom:'1rem',boxSizing:'border-box'}} />
          <label style={{display:'block',fontSize:'12px',fontWeight:'500',color:'#555',marginBottom:'4px'}}>Email</label>
          <input type="email" value={form.email} onChange={set('email')} required
            style={{width:'100%',padding:'9px 12px',border:'0.5px solid #ddd',borderRadius:'8px',fontSize:'14px',marginBottom:'1rem',boxSizing:'border-box'}} />
          <label style={{display:'block',fontSize:'12px',fontWeight:'500',color:'#555',marginBottom:'4px'}}>Password</label>
          <input type="password" value={form.password} onChange={set('password')} required minLength={8}
            style={{width:'100%',padding:'9px 12px',border:'0.5px solid #ddd',borderRadius:'8px',fontSize:'14px',marginBottom:'1.25rem',boxSizing:'border-box'}} />
          <button type="submit" disabled={loading}
            style={{width:'100%',padding:'11px',background:'#1a1a1a',color:'#fff',border:'none',borderRadius:'8px',fontSize:'14px',fontWeight:'500',cursor:'pointer'}}>
            {loading ? 'Creating account...' : 'Create account'}
          </button>
        </form>
        <p style={{fontSize:'13px',color:'#666',marginTop:'1.25rem',textAlign:'center'}}>
          Already have an account? <Link to="/login" style={{color:'#1a1a1a',fontWeight:'500'}}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}